<template>
	<Dropdown trigger="click" placement="bottom-end" :transfer="true" class="lang-switch"
		@on-click="changeLanguage">
		<a href="javascript:void(0)" class="lang-switch-trigger">
			<Icon type="md-globe" size="16" />
			<span class="lang-switch-label">{{ currentLabel }}</span>
			<Icon type="ios-arrow-down" size="14" />
		</a>
		<DropdownMenu slot="list" style="text-align: left;">
			<DropdownItem v-for="item in languages" :key="item.value" :name="item.value">
				<span :class="{ 'lang-switch-active': item.value === current }">{{ item.label }}</span>
			</DropdownItem>
		</DropdownMenu>
	</Dropdown>
</template>

<script>
	import {
		i18n,
		LANGUAGES,
		setLocale
	} from '../../language'

	export default {
		name: 'LanguageSwitch',
		props: {
			// 触发按钮与图标的颜色，默认继承父级文字颜色
			color: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				languages: LANGUAGES,
				current: i18n.locale
			}
		},
		computed: {
			currentLabel() {
				const item = this.languages.find(lang => lang.value === this.current)
				return item ? item.label : this.current
			}
		},
		methods: {
			changeLanguage(value) {
				if (!value || value === this.current) return
				this.current = value
				setLocale(value)
				if (this.$i18n) {
					this.$i18n.locale = value
				}
				this.$emit('change', value)
			}
		}
	}
</script>

<style scoped>
	.lang-switch-trigger {
		display: inline-flex;
		align-items: center;
		color: inherit;
		white-space: nowrap;
	}

	.lang-switch-trigger:hover {
		color: inherit;
		opacity: 0.85;
	}

	.lang-switch-label {
		margin: 0 4px;
	}

	.lang-switch-active {
		font-weight: bold;
		color: #2d8cf0;
	}
</style>
